/**
 * Selects an avatar from avatars-gen folder based on user ID
 * Uses djb2 hash algorithm to consistently map user IDs to one of 10 avatars (1-10)
 * @param userId - User ID string
 * @returns Path to avatar image (e.g., "/avatars-gen/5.webp")
 */
export function getAvatarByUserId(userId: string | null | undefined): string {
  if (!userId) {
    // Fallback to avatar 1 if no user ID provided
    return '/avatars-gen/1.webp';
  }

  // Convert to string to handle numbers
  const idString = String(userId);

  // djb2 hash algorithm for better distribution
  let hash = 5381;
  for (let i = 0; i < idString.length; i++) {
    hash = (hash << 5) + hash + idString.charCodeAt(i);
    hash = hash | 0; // Convert to 32-bit integer
  }

  // Map hash to avatar number 1-10
  const avatarNumber = (Math.abs(hash) % 10) + 1;
  return `/avatars-gen/${avatarNumber}.webp`;
}
